module.exports = __webpack_public_path__ + "img/45chedao.prt.4e0cd55d.jpg";